import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@/modules/common/components/Switch';
import Button from '@/modules/common/components/Button';
import Checkbox from '@/modules/common/components/Checkbox';
import TimeRange from '@/modules/common/components/TimeRange';
import TextField from '@/modules/common/components/TextField';
import InputGroup from '@/modules/common/components/InputGroup';

const Form = (props) => {
    const isVisibleExtraFields = (props.cfg.offer_name === 'Ingos');

    const handleChange = (prop, depend) => (event) => {
        const value = (event.target.hasOwnProperty('value')) ? event.target.value : event.target.checked;
        let values = {...props.values, [prop]: value};
        if (depend && value === false) {
            values[depend] = false;
        }
        props.setValues(values);
    };

    const handleFocus = (prop) => () => {
        props.setErrors({...props.errors, [prop]: ''});
    };

    return (
        <>
            <form id="form-settings" onSubmit={props.onSubmit}>
                <FormGroup>
                    <TextField label="Интервал уникальности лидов (дн.)" type="number"
                               value={props.values.leadsUniqueDays}
                               onChange={handleChange('leadsUniqueDays')}
                               error={props.errors.leadsUniqueDays > 0}
                               helperText={props.errors.leadsUniqueDays}
                               onFocus={handleFocus('leadsUniqueDays')}
                               inputProps={{min: 0, max: 360}}
                    />
                </FormGroup>
                <FormGroup>
                    <Switch label={'Отображать в меню "Лиды"'}
                            checked={props.values.showInLeadsMenu} onChange={handleChange('showInLeadsMenu')}
                    />
                </FormGroup>
                <FormGroup>
                    <Switch label={'Отображать в меню "Заметки"'}
                            checked={props.values.showInNotesMenu} onChange={handleChange('showInNotesMenu')}
                    />
                </FormGroup>
                <FormGroup>
                    <Switch label={'Отображать столбец "Тип заявки"'}
                            checked={props.values.showTypeCol} onChange={handleChange('showTypeCol')}
                    />
                </FormGroup>
                <FormGroup>
                    <Switch label={'Отображать столбец "Дата/Время статуса"'}
                            checked={props.values.showDtsCol} onChange={handleChange('showDtsCol')}
                    />
                </FormGroup>
                <InputGroup title={'Столбец "Adv Sub"'} direction="row">
                    <Switch label="Отображать"
                            checked={props.values.showAdvSub2Col}
                            onChange={handleChange('showAdvSub2Col', 'affiliateShowAdvSub2Col')}
                    />
                    <Checkbox label="Отображать у партнеров"
                              checked={props.values.affiliateShowAdvSub2Col}
                              onChange={handleChange('affiliateShowAdvSub2Col')}
                              disabled={!props.values.showAdvSub2Col}
                    />
                </InputGroup>
                <FormGroup>
                    <Switch label={'Отображать столбец "ID транзакции"'}
                            checked={props.values.showTransactionIdCol} onChange={handleChange('showTransactionIdCol')}
                    />
                </FormGroup>
                <InputGroup title="Telegram бот" className="input-group-telegram">
                    <TimeRange value={props.values.botTime}
                               setValue={(value) => props.setValues({...props.values, botTime: value})}
                               error={props.errors.botTime}
                               setError={(value) => props.setErrors({...props.errors, botTime: value})}
                    />
                    <TextField label="Интервал (мин.)" type="number"
                               value={props.values.botInterval}
                               onChange={handleChange('botInterval')}
                               error={props.errors.botInterval.length > 0}
                               helperText={props.errors.botInterval}
                               onFocus={handleFocus('botInterval')}
                               inputProps={{min: 0}}
                    />
                </InputGroup>
                {(isVisibleExtraFields)
                    ? <InputGroup title="Дополнительные настройки" className="input-group-extra-fields">
                        <Switch label="Автоматическая отправка отчета по E-Mail"
                            checked={props.values.extraFlag1}
                            onChange={handleChange('extraFlag1')}
                        />
                    </InputGroup>
                    : null
                }
            </form>
            <div className="submit">
                <Button form="form-settings" type="submit" disabled={props.disabled}>
                    Сохранить
                </Button>
            </div>
        </>
    );
};

Form.propTypes = {
    cfg: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setErrors: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default Form;
